export const imageCodes = {
    contact: {
        code: "${merchantId}_tmpl_img_9",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fdeli.jpg?alt=media&token=af08badb-ed44-4a13-a396-dcdeb32b36f5"
    }
}

export const titleCodes = {

    contact: {
        code: "${merchantId}_tmpl_title_12",
        title: "ပစ္စည်းမှန် စျေးတန် စေတနာထက်သန် တဲ့ စားဖိုဆောင် ကို သတိရလိုက်ပါ"
    },
}

export const textCodes = {

    addr1: {
        code: "${merchantId}_tmpl_text_7",
        text: "ဆိုင်လိပ်စာ :"
    },

    addr2: {
        code: "${merchantId}_tmpl_text_7",
        text: "အမှတ် 007, Building B, Highway Complex အိမ်ရာ၊ ကမာရွတ်မြို့နယ်၊ ရန်ကုန်။"
    },

    addr3: {
        code: "${merchantId}_tmpl_text_38",
        text: "(ဂရန်းဟံသာ ဆေးရုံဘေး၊ အရိုးဆေးရုံကြီးမျက်နှာချင်းဆိုင်)"
    },

    hotline: {
        code: "${merchantId}_tmpl_text_5",
        text: "Hotline : 09 440 400 123"
    },

    viber: {
        code: "${merchantId}_tmpl_text_4",
        text: "Viber : 09 440 400 123"
    },

    email: {
        code: "${merchantId}_tmpl_text_3",
        text: "Email : sarphosaung@falconbreeze.com"
    }
}